import { lazyForPaint } from 'react-loosely-lazy';

export const QueueGroupsSection = lazyForPaint(
	() => import(/* webpackChunkName: "jsm-sidebar-queue-groups-section" */ './main'),
	{
		ssr: true,
	},
);
